/**
 * "Make it monthly?" — remembering a donor's "no thanks" on this device (0.9.0).
 *
 * The suggested amount itself comes from the server (`POST /checkout/quote`'s
 * `monthly_suggestion`); nothing here calculates money.
 *
 * The offer is shown at most once per checkout. A donor who says "no thanks" is not asked again on
 * this device for thirty days. Storage failures (private windows, blocked site data) only mean the
 * offer may be shown again; they never stop checkout.
 */

const DECLINE_PREFIX = 'anudan_monthly_prompt_declined_';
const DECLINE_REMEMBER_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * Whether the donor said "no thanks" on this device recently.
 *
 * @param {number} fundId
 * @return {boolean}
 */
export function declinedRecently( fundId ) {
	try {
		const at = parseInt( window.localStorage.getItem( DECLINE_PREFIX + String( fundId ) ) || '', 10 );

		return Number.isFinite( at ) && Date.now() - at < DECLINE_REMEMBER_MS;
	} catch ( error ) {
		return false;
	}
}

/**
 * Remembers a "no thanks" on this device.
 *
 * @param {number} fundId
 * @return {void}
 */
export function rememberDecline( fundId ) {
	try {
		window.localStorage.setItem( DECLINE_PREFIX + String( fundId ), String( Date.now() ) );
	} catch ( error ) {
		// Storage unavailable: the offer may be shown again next time, which is harmless.
	}
}
